export default class FinalizarAprovacao {
    idVersao: number;
    observacao: string;
    aprovado: boolean;
    motivoReprovacao: string;

    constructor(
        idVersao: number = 0,
        observacao = "",
        aprovado = false,
        motivoReprovacao: string = ""
    ) {
        this.idVersao = idVersao;
        this.observacao = observacao;
        this.aprovado = aprovado;
        this.motivoReprovacao = motivoReprovacao;
    }
}